import React, { useState } from 'react';
import { Box, Card, CardContent, Button, Typography, Alert, Grid } from '@mui/material';
import axios from 'axios';

const PaymentUpload = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a CSV file');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/payments/upload`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setSuccess(`Uploaded ${res.data.successCount} payments`);
      setError(res.data.errors.join(', ') || '');
    } catch (err) {
      setError(err.response?.data?.error || 'Upload failed');
      setSuccess('');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4, mb: 4 }}>
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h5" component="h1" gutterBottom align="center" color="primary">
            Upload Payments
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <input
                type="file"
                accept=".csv"
                onChange={e => setFile(e.target.files[0])}
                style={{ margin: '16px 0' }}
              />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                size="large"
                sx={{ mt: 2, px: 4 }}
              >
                Upload CSV
              </Button>
            </Grid>
          </Grid>
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentUpload;